const ALLOWED_USERNAME_REGEX = '^[a-z0-9_]+$';

const ALLOWED_VIDEO_HOST_WHITELIST = [
  'youtube.com',
  'vimeo.com',
  'www.youtube.com',
  'www.vimeo.com',
];

export { ALLOWED_USERNAME_REGEX, ALLOWED_VIDEO_HOST_WHITELIST };
